import React from "react";
import { connect } from "react-redux";

import "./Unassigned.css";

import history from "../../history";

class Unassigned extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            render: false
        };
    }

    componentDidMount() {
        if (this.props.currentUser.ouID !== null) history.push("/");
        else if (this.props.currentUser.ouID === null) this.setState({ render: true });
    }

    componentDidUpdate() {
        if (this.props.currentUser.ouID !== null) history.push("/");
        else if (!this.state.render) this.setState({ render: true });
    }

    render() {
        if (this.state.render) {
            return (
                <React.Fragment>
                    <div className="inactive-component ui container">
                        <div className="ui container">
                            <div className="ui grid">
                                <div className="column">
                                    <h2 className="ui icon header">
                                        <i className="exclamation triangle icon"></i>
                                        <div className="header">Twoje konto nie jest przypisane do jednostki organizacyjnej</div>
                                    </h2>
                                </div>
                            </div>
                            <div className="ui divider" />
                            <h3 className="header">Aby skorzystać z tej funkcji twoje konto musi być przypisane do jednostki organizacyjnej</h3>
                            <div className="content">Aby przypisać konto skontaktuj się z przełożonym lub administratorem</div>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
        else return null;
    }
}

const mapStateToProps = state => ({ currentUser: state.user.current });

export default connect(mapStateToProps, null)(Unassigned);